import { render, staticRenderFns } from "./BankDataView.vue?vue&type=template&id=56a04764&scoped=true"
import script from "./BankDataView.vue?vue&type=script&lang=ts"
export * from "./BankDataView.vue?vue&type=script&lang=ts"
import style0 from "./BankDataView.vue?vue&type=style&index=0&id=56a04764&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a04764",
  null
  
)

export default component.exports